import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { GlassCard } from '../components/ui/GlassCard';
import { Check } from 'lucide-react';
import { useEmbed, navigateTop } from '../hooks/useEmbed';

export const Pricing = () => {
  const { t } = useTranslation();
  const isEmbed = useEmbed();

  const handleTopUp = () => {
    if (isEmbed) {
      navigateTop('https://api.getinfinityblue.com/pricing');
    } else {
      window.location.href = 'https://api.getinfinityblue.com/pricing';
    }
  };

  const features = [
    t('pricing.featureNoFee'),
    t('pricing.featurePayAsYouGo'),
    t('pricing.featureNeverExpires'),
    t('pricing.featureAllModels'),
  ];

  return (
    <div className="container mx-auto px-6 py-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-20"
      >
        <h1 className="text-5xl font-display font-bold mb-6">{t('pricing.title')}</h1>
        <p className="text-xl text-gray-400">
          {t('pricing.subtitle')}
        </p>
      </motion.div>

      <div className="max-w-lg mx-auto">
        <GlassCard className="p-10 border-glass-cyan shadow-[0_0_40px_rgba(0,240,255,0.1)] text-center">
          {/* Recharge Amount */}
          <p className="text-lg text-gray-400 mb-2">{t('pricing.rechargeAmount')}</p>
          <p className="text-5xl font-display font-bold text-white mb-4">{t('pricing.onlyCny')}</p>

          {/* Discount Badge */}
          <div className="inline-flex flex-col items-center gap-1 px-5 py-3 rounded-lg bg-glass-cyan/10 border border-glass-cyan/30 mb-8">
            <span className="text-glass-cyan font-bold text-lg">{t('pricing.discountBadge')}</span>
            <span className="text-gray-500 text-sm">{t('pricing.discountNote')}</span>
          </div>

          {/* CTA */}
          <button
            onClick={handleTopUp}
            className="glass-button-primary w-full text-lg py-3 mb-8"
          >
            {t('pricing.ctaTopUp')}
          </button>

          {/* Features */}
          <div className="grid grid-cols-2 gap-4">
            {features.map((feature, i) => (
              <div key={i} className="flex items-center gap-2 text-sm text-gray-300">
                <Check className="w-4 h-4 text-glass-cyan shrink-0" />
                {feature}
              </div>
            ))}
          </div>
        </GlassCard>
      </div>

      <div className="mt-12 text-center text-gray-500 text-sm">
        <p>{t('pricing.footnote')}</p>
      </div>
    </div>
  );
};
